<template>
  <div v-if="isShow" :style="domStyle" id="topTop">
    <!--    <div id="svgTemplate"></div>-->
    <object class="emb" :data="pictureUrl" type="image/svg+xml" ref="svgTemplate"></object>
    <!--        <embed :src="pictureUrl" width="100" height="100" type="image/svg+xml" ref="svgTemplate"/>-->
    <!--    <iframe :src="pictureUrl" width="100" height="100" style="border:0" ref="svgTemplate"></iframe>-->
    <!-- <button @click="startAnimate(10)">开始</button>
    <button @click="stopAnimate">停止</button> -->
  </div>
</template>
<script>
// import Vue from 'vue'

export default {
  name: '',
  props: ['primitives', 'fvSystemApi', 'parentObject'],
  created () {
    // 组件数据混淆
    this.mixin(this.primitives)
    // 组件大小位置初始化
    this.domStyle = {
      position: 'absolute',
      left: this.x + 'px',
      top: this.y + 'px',
      width: this.width + 'px',
      height: this.height + 'px'
    }
    this.enableStyle = {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: '0px',
      backgroundColor: '#ccbfbf',
      opacity: '0.5'
    }
    this.monitor()
    this.modelsPath = this.parentObject.modelsPath.slice(0)
    this.modelsPath.push(this.registerName)
    this.$store.registerModule(this.modelsPath, {
      state: {
        $: this
      }
    })
  },
  mounted () {
    // console.log(this.$refs.svgTemplate.contentWindow.document.body)
    this.$refs.svgTemplate.onload = () => {
      this.svgMethods = this.$refs.svgTemplate.contentWindow
      console.log(this.$refs.svgTemplate.contentWindow.document)
    }
  },
  data () {
    return {
      // 是否可用
      isEnable: false,
      // 是否显示
      isShow: true,
      // 组件大小位置,在created(创建完毕，挂载前)函数中初始化
      domStyle: {},
      currentWidth: '100%',
      currentHeight: '100%',
      animateArr: [{
        id: 'animateTransform1',
        dbVar: '采集站1.供水系统.GFJ_101_zs.PV'
      }, {
        id: 'animateTransform2',
        dbVar: '采集站1.供水系统.JBJ_010_kg.PV'
      }
        // , {
        //   id: 'animateTransform3',
        //   dbVar: '采集站1.供水系统.GFJ_103_zs.PV'
        // }, {
        //   id: 'animateTransform4',
        //   dbVar: '采集站1.供水系统.GFJ_104_zs.PV'
        // }
      ]
    }
  },
  computed: {
    currentUrl () {
      return this.pictureUrl
    }
  },
  methods: {
    // 动画绑点
    async associatedDbvar () {
      for (const value of this.judge) {
        if (value[animateId] && value[startStopVar] || value[speedVar]) {
          let res1 = await this.getRealData(value[startStopVar])
          let res2 = await this.getRealData(value[speedVar])
          if (!res1) {
            this.stopAnimate(value[animateId], res1)
          } else {
            this.startAnimate(value[animateId], res2)
          }
        }
      }
    },
    // 获取点实时数据
    getRealData (selVar) {
      return this.fvSystemApi.getReal(selVar)
    },
    stopAnimate () {
      console.log('停止')
      this.svgMethods.changeRotationSpeed('abc', '0s')
      this.svgMethods.changeRotationRepeatCount('abc', 'indefinite')
    },
    startAnimate (domID, res) {
      console.log('开始')
      this.svgMethods.changeRotationSpeed(domID, `${res / 10}s`)
      this.svgMethods.changeRotationRepeatCount(domID, 'indefinite')
    },
    // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /*
        参数：src 原json数据
        作用：混淆数据到当前对象
    */
    mixin (src) {
      for (var key in src) {
        this[key] = src[key]
      }
    },
    /*
        参数：e 鼠标信息
             domScale 窗口放大、缩小、偏移等信息
        作用：鼠标事件调用函数，无必要可不进行任何处理
    */
    doFixedEvent (e, domScale) {
    },
    /*
        参数：无
        作用：系统周期调用
    */
    onTimer () {
      if (!this.svgMethods) return
      this.associatedDbvar()
    },
    /*
        参数：无
        作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
    */
    onClose () {
      return new Promise((resolve) => {
        resolve()
      })
    },
    /*
        参数：scaleObj 重绘信息
        作用：组件需要重绘时触发
    */
    reDraw (scaleObj) {
      if (this.fontSize) {
        this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + 'px'
      }
      this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + 'px'
      this.$el.style.top = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + 'px'
      this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + 'px'
      this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + 'px'
      this.currentWidth = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + 'px'
      this.currentHeight = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + 'px'
    },
    /*
        参数：isShow 显示隐藏
        作用：设置组件整体显隐
    */
    Show (isShow) {
      this.isShow = !!isShow
    },
    /*
        参数：isEnable 是否可用
        作用：设置组件是否可用
    */
    Enable (isEnable) {
      this.isEnable = !isEnable
    },
    /*
        参数：无
        作用：更新svg图片展示
    */
    updateImg (value) {
      this.currentUrl = value
    },
    /*
        参数：无
        作用：监听组件内部属性
    */
    monitor () {
      // 内部属性 控制svg路径展示变化
      Object.defineProperty(this, 'Path', {
        set (value) {
          this.currentUrl = value
          this.$forceUpdate()
        },
        get () {
          return this.currentUrl
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvBadge/fvSvgDemo.vue